import { render, staticRenderFns } from "./task-details.vue?vue&type=template&id=51fe558f&scoped=true"
import script from "./task-details.vue?vue&type=script&lang=js"
export * from "./task-details.vue?vue&type=script&lang=js"
import style0 from "./task-details.vue?vue&type=style&index=0&id=51fe558f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fe558f",
  null
  
)

export default component.exports